/**
 * Hyros Functions
 *
 * Loads the Hyros Universal Script. Hyros identifies the account by the
 * product hash (the ph parameter), and tags every visitor who lands on a
 * tracked page with the application tag (!clicked unless the shop configured
 * a different one in Hyros).
 *
 * The script URL is assembled the same way Hyros builds it in their own
 * Universal Script snippet and in their WordPress plugin: the current page URL
 * travels along in ref_url so Hyros can attribute the visit.
 *
 * @see https://hyros-docs.vercel.app/docs/install/v1/standard-script.txt
 */

(function (pmw, undefined) {

	const HYROS_SCRIPT_ENDPOINT = "https://t.hyros.com/v1/lst/universal-script"

	/**
	 * Action tags recorded before the Universal Script finished loading.
	 *
	 * The purchase tag in particular is triggered during page load, so it
	 * regularly beats the async script to it. Those tags are queued here and
	 * flushed once window.hrs exists.
	 */
	let pendingTags = []

	const isHyrosApiReady = () => typeof window.hrs?.addLeadTag === "function"

	const flushPendingTags = () => {

		if (!isHyrosApiReady()) return

		while (pendingTags.length) {
			sendLeadTag(pendingTags.shift())
		}
	}

	const sendLeadTag = (tag) => {
		window.hrs.addLeadTag(tag)
		pmw.console.log("Hyros: " + tag + " tag sent")
	}

	/**
	 * Load the Hyros Universal Script
	 */
	pmw.loadHyrosPixel = () => {
		try {

			const config = pmwDataLayer?.pixels?.hyros

			if (!config?.product_hash) return

			const src = HYROS_SCRIPT_ENDPOINT +
				"?ph=" + encodeURIComponent(config.product_hash) +
				"&tag=" + encodeURIComponent(config.application_tag || "!clicked") +
				"&ref_url=" + encodeURI(document.URL)

			const script = document.createElement("script")
			script.type  = "text/javascript"
			script.async = true
			script.src   = src

			script.onload = () => {
				flushPendingTags()
			}

			script.onerror = () => {
				pendingTags = []
				pmw.console.log("Hyros: the Universal Script could not be loaded")
			}

			document.head.appendChild(script)

			pmwDataLayer.pixels.hyros.loaded = true

			pmw.console.log("Hyros: pixel loaded")

		} catch (e) {
			console.error(e)
		}
	}

	/**
	 * Add an action tag to the visitor journey
	 *
	 * window.hrs is created by the Universal Script once it has loaded. Tags
	 * fired before that are queued and flushed on load.
	 *
	 * @param {Object} hyrosData - Adapted Hyros data from the event payload
	 */
	pmw.hyrosAddLeadTag = (hyrosData) => {
		try {

			if (!hyrosData?.event_name) return

			if (!isHyrosApiReady()) {
				pendingTags.push(hyrosData.event_name)
				return
			}

			flushPendingTags()
			sendLeadTag(hyrosData.event_name)

		} catch (e) {
			console.error(e)
		}
	}

}(window.pmw = window.pmw || {}));
